import script from "./MySwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./MySwitch.vue?vue&type=script&lang=ts&setup=true"

import "./MySwitch.vue?vue&type=style&index=0&id=17cecdf1&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17cecdf1"]])

export default __exports__